import { Home, ArrowLeft } from 'lucide-react';

type Props = {
  code: 404 | 500;
  onBack: () => void;
};

export default function ErrorPage({ code, onBack }: Props) {
  const is404 = code === 404;

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="text-center max-w-md">

        <h1 className="text-7xl font-bold text-white mb-3">{code}</h1>
        <h2 className="text-xl font-bold text-white mb-2">
          {is404 ? 'Page not found' : 'Something went wrong'}
        </h2>
        <p className="text-blue-300 text-sm mb-8">
          {is404
            ? 'The page you\'re looking for doesn\'t exist or has been moved.'
            : 'An unexpected error occurred. Our team has been notified. Please try again.'}
        </p>

        <button
          onClick={onBack}
          className="inline-flex items-center gap-2 px-6 py-3 bg-white text-blue-700 font-semibold rounded-md hover:bg-blue-50 transition-colors text-sm"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to home
        </button>
      </div>
    </div>
  );
}
